/*=============================================== Language context ===============================================*/

import { createContext, useState, useEffect } from "react"

const languageNames = { js: "js", ts: "ts" } as const
export type LanguageTypes = keyof typeof languageNames | undefined

export type LangContextType = {
    language: LanguageTypes
    setLanguage: (language: LanguageTypes) => void
    handleChangeLang: (language: LanguageTypes) => void
}

export const LangContext = createContext<LangContextType | null>(null)

export const LangProviderWrapper = ({ children }: LangProviderProps) => {
    const [language, setLanguage] = useState<LanguageTypes>(undefined)

    useEffect(() => {
        const selectedLang: any = localStorage.getItem("language")

        if (selectedLang !== null) {
            setLanguage(selectedLang)
        } else {
            setLanguage("js")
            localStorage.setItem("language", "js")
        }
    }, [])

    const handleChangeLang = (selectedLanguage: LanguageTypes) => {
        setLanguage(selectedLanguage)
        localStorage.setItem("language", selectedLanguage || "")
    }

    return (
        <LangContext.Provider
            value={{ language, setLanguage, handleChangeLang }}
        >
            {children}
        </LangContext.Provider>
    )
}

interface LangProviderProps {
    children?: any
}
